import $ from 'jquery';

import widgetFactory from '../widgetFactory';

const widgetName = 'elementLoading';

export default widgetFactory(widgetName, {
  _create() {
    this._super(widgetName);
    this.element.addClass('has-loader');
    this._wrap();
    this.elements.$spinner = this._createSpinner().insertAfter(this.element);
  },

  _wrap() {
    const $wrapper = $('<wrap>').css('position', 'relative');

    this.element.wrap($wrapper);
  },

  /**
   * @returns {jQuery}
   * @private
   */
  _createSpinner() {
    return $('<i class="icon-spin icon-spinner  spinnerLoader"></i>');
  },

  show() {
    this.elements.$spinner.addClass('is-visible');
  },

  hide() {
    this.elements.$spinner.removeClass('is-visible');
  },
});
